// React-PDF fonts don't support U+202F (narrow no-break space) used by fr-FR number formatting,
// which causes it to render as "/" in the generated PDF so we replace it with a regular space.
const PDF_UNSUPPORTED_WHITESPACE_REGEX = /\u202F/g
const PDF_SUPPORTED_NON_BREAKING_WHITESPACE = '\u00A0'

export const sanitizeCurrencyForPdf = (currency: string) => {
  return currency.replace(PDF_UNSUPPORTED_WHITESPACE_REGEX, PDF_SUPPORTED_NON_BREAKING_WHITESPACE)
}
